import { useMemo } from "react";
import { PresenceKind } from "@common/types/presence-nats";
import { useScope } from "@state/scopeContext.lib";
import { usePresenceViewers } from "./usePresenceViewers";
import { usePublishPresence } from "./usePublishPresence";

/**
 * Call `notifyTyping` on every keystroke (it throttles itself); `typingUserIds`
 * are the other users currently typing in the conversation.
 */
export const useChatTyping = (conversationId: string | null | undefined) => {
    const { workspaceId } = useScope();

    const publishedTarget = useMemo(
        () =>
            workspaceId && conversationId
                ? {
                      workspaceId,
                      kind: PresenceKind.CHAT,
                      targetId: conversationId,
                  }
                : null,
        [workspaceId, conversationId],
    );
    const observedTarget = useMemo(
        () =>
            publishedTarget
                ? {
                      ...publishedTarget,
                      scope: { workspaceId: publishedTarget.workspaceId },
                  }
                : null,
        [publishedTarget],
    );

    const { heartbeat } = usePublishPresence(publishedTarget, {
        mode: "onDemand",
    });
    const typingUserIds = usePresenceViewers(observedTarget);

    return { typingUserIds, notifyTyping: heartbeat };
};
